module.exports = __webpack_public_path__ + "img/ordersManager-active.111eb2f0.svg";